// Status badge + helpers for service tickets.

import React from "react";

const STATUS_COLORS = {
  requested:        "bg-slate-100 text-slate-700",
  accepted:         "bg-blue-50 text-blue-700",
  in_progress:      "bg-amber-50 text-amber-800",
  ready_for_pickup: "bg-emerald-50 text-emerald-800",
  delivered:        "bg-emerald-600 text-white",
  cancelled:        "bg-rose-50 text-rose-700",
};

export const friendlyStatus = (s, t) => {
  const KEY_MAP = {
    requested:        "racketLab.tickets.statusRequested",
    accepted:         "racketLab.tickets.statusAccepted",
    in_progress:      "racketLab.tickets.statusInProgress",
    ready_for_pickup: "racketLab.tickets.statusReadyForPickup",
    delivered:        "racketLab.tickets.statusDelivered",
    cancelled:        "racketLab.tickets.statusCancelled",
  };
  return t(KEY_MAP[s] || "racketLab.tickets.statusRequested");
};

export const StatusBadge = ({ status, t }) => (
  <span
    className={`inline-block rounded px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wide ${
      STATUS_COLORS[status] || STATUS_COLORS.requested
    }`}
    data-testid={`racket-lab-ticket-status-${status}`}
  >
    {friendlyStatus(status, t)}
  </span>
);
